import { Card, styled } from '@mui/material';

export const Wrapper = styled(Card)``;
